export enum Framework {
    UNITY = "unity",
    OTHER = "other",
}